import React, { useState, useEffect } from 'react'

import { Formik } from 'formik';
import { useSelector, useDispatch } from 'react-redux'
import * as yup from 'yup';

import { getReport, cleanReport } from '../../../store/reports/reports.actions';
import { getAllCustomers } from '../../../store/customers/customers.actions';

// Components

import Button from '../../UI/Button/Button';
import SelectInput from '../../UI/FormInput/SelectInput';
import DownloadReportButton from '../../UI/DownloadReportButton/DownloadReportButton';
import Loader from '../../UI/Loader/Loader';

// Constants

import { REPORT_TYPES } from '../../../config/constants';

export default function ReportBalanceFlow({setShowBalanceFlowReportModal}) {
  const [reportUrl, setReportUrl] = useState(null);
  const reports = useSelector((state) => state.reports.reports);
  const customers = useSelector((state) => state.customers.customersAll);
  const dispatch = useDispatch();

  // Generate Report

  const generateBalanceFlowReport = async (values, actions) => {
    setReportUrl(null);

    const data = {
      customer_id: values.customer_id ? values.customer_id : null,
      export: true,
    }

    dispatch(getReport(data, REPORT_TYPES.balanceflow));
  }


  // Set up report download url

  useEffect(() => {
    if (reports.data) {
      const url = window.URL.createObjectURL(new Blob([reports.data]));
      setReportUrl(url);
    }
  }, [reports]);


  // Cleanup the storage on load

  useEffect(() => {
    dispatch(cleanReport());
    dispatch(getAllCustomers())
  }, [dispatch])

  return (
    <>

      {(customers?.isLoading || customers?.error) &&
        <Loader
          message={'Cargando...'}
          error={customers.error}
          action={() => dispatch(getAllCustomers())}
          dark={true}
      />}

    {!customers?.isLoading && customers?.data &&
      <>
        <Formik
            initialValues={{
              customer_id: ''
            }}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => generateBalanceFlowReport(values, actions)}
          >

            {props => (
            <>

              {/* Form Inputs */}

              <>

                <SelectInput
                  formik={props}
                  fieldName={'customer_id'}
                  label={'Cliente'}
                  placeholder={'Seleccione'}
                  options={customers?.data ? customers?.data.map(option => ({ value: option.id, label: option.name })) : []}
                />

                {/* Loader */}

                {(reports?.isLoading || reports?.error) &&
                  <Loader
                    message={'Generando reporte...'}
                    error={reports.error}
                    action={() => getReport(props.values, REPORT_TYPES.balanceflow)}
                    dark={true}
                />}

                {/* Download Report Button */}

                {!reports?.isLoading && reports.data && reportUrl &&
                <DownloadReportButton
                  fileUrl={reportUrl}
                  fileName={'reporte-data-plana'}
                />}


                {/* Form actions */}

                <div className='form-actions'>

                  <Button
                    action={() => setShowBalanceFlowReportModal(false)}
                    label={'Cancelar'}
                    secondaryStyle={true}
                    disabled={reports?.isLoading}
                  />

                  <Button
                    action={props.handleSubmit}
                    label={'Generar'}
                    disabled={reports?.isLoading}
                    isLoading={reports?.isLoading}
                  />

                </div>
              </>

            </>)}

        </Formik>

      </>}
    </>
  )
}

// Form validation schema

const validationSchema = yup.object().shape({
  customer_id: yup.string().required('Este campo es obligatorio'),
});
